type DeceasedDetailItemProps = {
  label: string;
  value: React.ReactNode;
};

export function AdDetailsCardRow({ label, value }: DeceasedDetailItemProps) {
  return (
    <div className="text-sm">
      <div className="text-column-gray-400 font-medium">{label}</div>
      {value}
    </div>
  );
}
